"use client";

import type React from "react";
import { ProfessionalSidebar } from "./professional-sidebar";

interface NavigationSection {
  title: string;
  items: any[];
}

interface DashboardLayoutProps {
  navigation: NavigationSection[];
  currentPath: string;
  onNavigate: (path: string) => void;
  user?: {
    name: string;
    email: string;
    image?: string;
    role?: string;        // Changed to string to be more flexible
    accountType?: string; // 👈 ADD THIS FIELD
  };
  onSignOut: () => void;
  children: React.ReactNode;
  className?: string;
}

export function DashboardLayout({
  navigation,
  currentPath,
  onNavigate,
  user,
  onSignOut,
  children,
  className = "",
}: DashboardLayoutProps) {
  
  return (
    <div
      className={`flex h-screen bg-gradient-to-br from-gray-50 to-gray-100 ${className}`}
    >
      <ProfessionalSidebar
        navigation={navigation}
        currentPath={currentPath}
        onNavigate={onNavigate}
        user={user} 
        onSignOut={onSignOut}
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <main className="flex-1 overflow-y-auto p-4">
          <div className="max-w-7xl mx-auto">{children}</div>
        </main>
      </div>
    </div>
  );
}